// TODO: make naming of file more obvious

export function isLinuxServer() {
	return process.cwd().trim().substring(0, 11) === "/etc/init.d" || process.cwd().trim().substring(0, 1) === "/";
}

export function getBasePhotoPath() {
	return isLinuxServer() ? `/var/www/html/recipes/api/static/photos` : `G:\\Websites\\recipes\\api\\static\\photos`;
}
